import { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "@/hooks/useToast"
import { AppointmentContext, useAppointmentContext } from "@/modules/waiting-room/contexts/appointment-context"
import { WaitingRoomAppointments } from "@/modules/waiting-room/services/WaitingRoomAppointmentsQuery"

export const useDrawerCloserWhenAppointmentNoLongerPresent = (appointmentGroups: WaitingRoomAppointments) => {
  const { t } = useTranslation()

  const setSelectedWaitingRoomAppointmentId = useAppointmentContext(
    (state) => state.setSelectedWaitingRoomAppointmentId,
  )
  const setWaitingRoomPreviewDialog = useAppointmentContext((state) => state.setWaitingRoomPreviewDialog)

  const store = useContext(AppointmentContext)

  useEffect(() => {
    const selectedWaitingRoomAppointmentId = store?.getState().selectedWaitingRoomAppointmentId
    const shouldBeSelectedPreviousAppointmentId = store?.getState().shouldBeSelectedPreviousAppointmentId

    if (!selectedWaitingRoomAppointmentId) return

    const isAppointmentStillPresent = appointmentGroups
      .flatMap((d) => d.slots)
      .flatMap((s) => s.appointments)
      .some((a) => a.id === selectedWaitingRoomAppointmentId)

    if (!isAppointmentStillPresent) {
      if (shouldBeSelectedPreviousAppointmentId) {
        setSelectedWaitingRoomAppointmentId(shouldBeSelectedPreviousAppointmentId)
        toast({
          description: t("scheduling.waitingRoom.noSelectedAppointment"),
        })
      } else {
        setSelectedWaitingRoomAppointmentId(null)
        setWaitingRoomPreviewDialog(false, false)
        toast({
          description: t("scheduling.waitingRoom.noSelectedAndFormerAppointment"),
        })
      }
    }
  }, [appointmentGroups, setSelectedWaitingRoomAppointmentId, setWaitingRoomPreviewDialog, store, t])
}
